import { action, extendObservable, runInAction } from 'mobx';
import { apiFetchGet, apiFetchUrlGet } from '../helpers/api';
import store from './store';
// import _ from 'lodash';
import { GET_WAR, DOC_TYPE_WAR } from '../helpers/constants';
import * as local from '../helpers/localStorage';

export default class WARStore {
    constructor(factory) {
        this.factory = factory;
        this.validDocuments = [];

        extendObservable(this, {
            data: [],
            loading: false,

            fetch: async () => {
                const json = await apiFetchGet(GET_WAR, this.factory.user.token);
                const data = json.WorthARead;
                this.validDocuments = [];

                runInAction(() => {
                    this.data = data;
                    this.loading = true;
                });

                this.fetchImages();

                if (window.offlineApiExtension) {
                    this.setWarDocList(data);
                    window.offlineApiExtension.cleanIdbContent_Documents(store.documents.buildCompareString(DOC_TYPE_WAR), this.validDocuments);
                }
            },

            setLoading: action(loading => {
                this.loading = loading;
            }),

            fetchImages: async () => {
                const token = store.user.token;
                var war = this.data;

                await Promise.all(
                    war.map(async (element, index, array) => {
                        await Promise.all(
                            element.WarDocs.map(async (doc, index, array) => {
                                const url = await apiFetchUrlGet(
                                    doc.ImageUrl,
                                    token,
                                ).catch(e => {});
                                if (!url) return (array[index]['localImageUrl'] = null);
                                return (array[index]['localImageUrl'] = url);
                            }),
                        );
                        const url = await apiFetchUrlGet(element.ImageUrl, token).catch(e => {});
                        array[index]['localImageUrl'] = url;
                    }),
                );

                runInAction(() => {
                    this.data = war;
                });

                local.setUpWar();

                runInAction(() => {
                    this.loading = false;
                });
            },

            getAllChildCategories: parentCategoryId => {
                return this.data.filter(war => {
                    return war.ParentId === Number(parentCategoryId);
                });
            },

            getCategory: categoryId => {
                return this.data.filter(war => {
                    return war.WarCatId === categoryId;
                })[0];
            },

            setWarDocList: (data) => {
                let arrValidDocuments = [];

                data.forEach(function(item) {
                    item.WarDocs.forEach(function(document) {
                        //build the valid doc key list ready to clean indexedDB
                        const docKey = store.documents.buildDocKey(DOC_TYPE_WAR, '0', document.WarDocId.toString());
                        arrValidDocuments.push({docKey});
                    });
                });

                if(arrValidDocuments.length > 0) {
                    this.validDocuments = this.validDocuments.concat(arrValidDocuments);
                }
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/WARStore.js